import React, { useState } from "react";
import { Arrow, Button, Container, Line } from "../../Styles/Global.Styled";
import RangeSlider from "../Inputs/RangeSlider";
import Checkbox from "../Inputs/Checkbox";
import { css } from "styled-components";
import OptionsInput from "../Inputs/OptionsInput";

const cntStyle = css`
  flex-direction: column;
  gap: 1vh;
  padding: 0.5vh 0 1vh;
`;
const custBttn = css`
  justify-content: space-between;
  font-size: 1.75vh;
  /* padding-right: 1vh; */
  padding: 0.5vh 0.5vh 0.5vh 0;
  /* border:2px solid red; */
`;
const arrowStyle = css`
  padding: 0.5vh;
  border-radius: 0px;
  border-width: 0 0.25vh 0.25vh 0;
  border-color: ${({ theme }) => theme.shadowColor};
`;
const optionCntStyle = (open) => css`
  flex-direction: column;
  gap: 1vh;
  display: ${open ? "flex" : "none"};
`;
const colorStyle = css`
  border-color: lightgrey;
  border-width: 1px;
`;

const Filter = ({ filterType, setFilters, isOpen, index }) => {
  const [open, setOpen] = useState(
    filterType.selectedValues?.length > 0 || isOpen
  );

  const handleSelectionFilter = ({ value }) => {
    setFilters((prevFilters) =>
      prevFilters.map((filter) => {
        if (filter.name !== filterType.name) return filter;

        const updatedSelections = filter.selections.map((selection) =>
          selection.name === value
            ? { ...selection, selected: !selection.selected }
            : selection
        );

        return {
          ...filter,
          selections: updatedSelections,
        };
      })
    );
  };

  const handleSliderFilter = (e) => {
    return setFilters((prev) => {
      console.log("prev Filter", prev);
      const prevData = [...prev];
      const index = prevData.findIndex((item) => item.name === filterType.name);

      if (index !== -1) {
        if (
          e.target.id === "max" &&
          parseInt(e.target.value) <= prevData[index].max &&
          parseInt(e.target.value) > prevData[index].minValue
        ) {
          prevData[index].maxValue = e.target.value;
        }
        if (
          e.target.id === "min" &&
          parseInt(e.target.value) >= prevData[index].min &&
          parseInt(e.target.value) < prevData[index].maxValue
        ) {
          prevData[index].minValue = e.target.value;
        }
      }

      return prevData;
    });
  };

  return (
    <>
      <Container $baseStyle={cntStyle}>
        <Button $baseStyle={custBttn} onClick={() => setOpen(!open)}>
          {filterType.name}
          <Arrow $direction={open ? "up" : "down"} $baseStyle={arrowStyle} />
        </Button>
        <Container $baseStyle={optionCntStyle(open)}>
          {filterType.type === "selection" ? (
            filterType.selections?.map((selection) => (
              <Checkbox
                key={selection.name}
                value={selection.name}
                isChecked={selection.selected}
                disabled={selection.disabled}
                handleChange={handleSelectionFilter}
              />
            ))
          ) : filterType.type === "sorting" ? (
            <OptionsInput
              properties={filterType}
              setForm={setFilters}
              index={index}
              isColumn={true}
            />
          ) : filterType.type === "range" ? (
            <RangeSlider
              min={filterType.min}
              max={filterType.max}
              minValue={filterType.minValue}
              maxValue={filterType.maxValue}
              handleChange={handleSliderFilter}
              step={0.15}
            />
          ) : null}
        </Container>
      </Container>
      <Line $baseStyle={colorStyle} />
    </>
  );
};

export default Filter;
